import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';

const posDef: BnrGpPosModel[] = [];

// Gesetzliche Weiterbildungspflicht
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215001, 2216001],
		group: 'gwp',
		posText: 'Weiterbildung IDD ',
		posDesc: 'Voraussetzung für die Bonifikation ist der Nachweis von 15 Weiterbildungsstunden im Geschäftsjahr',
		planKey: 'idd',
		einheit: Einheit.stck,
	}),
);

// Vertriebsschwerpunkte (außerhalb der Maximierung)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215005, 2216005],
		group: 'vss',
		posText: 'Qualität in Beratung und Vertrieb',
		posDesc: 'Führungskraft beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: '',
		einheit: Einheit.quali,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215010, 2216010],
		group: 'vss',
		posText: 'Firmen Kraft in Kleinflotten und Fuhrparkmodellen',
		posDesc: 'Langfristige Neustück',
		planKey: '',
		einheit: Einheit.stck,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [PosUnDef, PosUnDef],
		group: 'vss',
		posText: 'Sach Firmen',
		posDesc: 'Gekappte Meldejahresschadenquote der Geschäftsstelle',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215030, 2216030],
		group: 'vss',
		posText: 'Unternehmensschutz',
		posDesc: 'Langfristige Neustück',
		planKey: 'privatundunternehemsschutz',
		einheit: Einheit.stck,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215035, 2216035],
		group: 'vss',
		posText: 'Unfall Anschlussgeschäft',
		posDesc: 'Neu-/Mehrbeitrag ohne Anpassungen des Vertragspotentials gemäß Aktionsliste (Nr.25563)',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Eingangshürde
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215041, 2216041],
		group: 'eh',
		posText: 'Sach Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215042, 2216042],
		group: 'eh',
		posText: 'Unfall und Sach Firmen',
		posDesc: 'Bewertung ohne Anpassung',
		planKey: 'unfallbew',
		einheit: Einheit.bew,
	}),
);

// Nach Eingangshürde (innerhalb einer Maximierung von 8.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215111, 2216111],
		group: 'neh',
		posText: 'Sach Firmen ohne Kraft',
		posDesc: 'Bewertung',
		planKey: 'fsachokraftoanpbew',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215121, 2216121],
		group: 'neh',
		posText: 'Kraft Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215131, 2216131],
		group: 'neh',
		posText: 'Rechtsschutz Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215141, 2216141],
		group: 'neh',
		posText: 'Sach Firmen ohne Kraft',
		posDesc: 'Bestandszuwachsbeitrag',
		planKey: 'fsachokraftoanpbew',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [2215150, 2216151],
		group: 'neh',
		posText: 'Unfall',
		posDesc: 'Bewertung ohne Anpassung',
		planKey: 'unfallbew',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);

// GeschäftsplanPlus (ohne Eingangshürde und außerhalb der Maximierung)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [3815021, 3816021],
		group: 'gpplus',
		posText: 'Unfall',
		posDesc: 'Bewertung ohne Anpassung: GS-Teamziel',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [3815022, 3816022],
		group: 'gpplus',
		posText: '',
		posDesc: 'Unfall Bestandszuwachs Stück',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Teamausschreibung
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: [3815400, 3816400],
		group: 'gpplus',
		posText: 'Teamausschreibung',
		posDesc: 'Platzierung in den Positionen im GSW der Vertriebsdirektion',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(new BnrGpPosModel({ year: 2026, posId: [PosUnDef, PosUnDef], group: 'gpplus', posText: '', posDesc: 'Kundenzuwachs', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: [PosUnDef, PosUnDef], group: 'gpplus', posText: '', posDesc: 'Cross-Selling', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: [PosUnDef, PosUnDef], group: 'gpplus', posText: '', posDesc: 'Meine Allianz', planKey: '', einheit: Einheit.nogoal }));

export const BsgPositionen = posDef;
